// Functional Package imports
import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Container } from './styles';

export const LoadingScreen = (props) => {
  return (
    <Container container>
      <Skeleton height={80} />
      <Skeleton variant="rectangular" height={250} />
    </Container>
  );
};

export const ScoreLoading = () => {
  return (
    <Container container>
      <Skeleton style={{ marginTop: 10 }} width={'40%'} height={50} />

      {Array.from(new Array(5)).map((d, i) => (
        <LoadingScreen key={i} />
      ))}
    </Container>
  );
};

export default LoadingScreen;
